export const ActionType = Object.freeze({
	CREATE: 'create',
	EDIT: 'edit',
});
